/**
 * Mapa „nazwa ikony (lucide) → komponent Phosphor" — pilot stylu DUOTONE (decyzja Eugenii
 * 2026-09-16). Ikony w apce są keyed nazwami lucide (menu/zakładki); tu tłumaczymy je na
 * odpowiedniki Phosphor, żeby renderować w wariancie `weight="duotone"`. Brak mapowania →
 * `Cube` (neutralny fallback). NIE zastępuje globalnego `resolveIcon` — używane punktowo
 * (TabBar, nagłówek kartoteki) w pilocie.
 */
import type { ComponentType } from 'react';
import {
  AddressBook,
  Airplane,
  Bank,
  Briefcase,
  Buildings,
  CalendarBlank,
  Cube,
  Database,
  EnvelopeSimple,
  File,
  Files,
  FileText,
  Folder,
  Gear,
  GitBranch,
  type IconProps,
  IdentificationBadge,
  ListChecks,
  Package,
  Plug,
  Receipt,
  ShieldCheck,
  SquaresFour,
  Storefront,
  UserGear,
  UsersThree,
  Wallet,
  Warehouse,
} from '@phosphor-icons/react';

export type PhosphorIcon = ComponentType<IconProps>;

const PHOSPHOR_BY_LUCIDE_NAME: Record<string, PhosphorIcon> = {
  Briefcase,
  UserCog: UserGear,
  BadgeCheck: IdentificationBadge,
  Building2: Buildings,
  Contact: AddressBook,
  Settings: Gear,
  FileText,
  Receipt,
  File,
  Mail: EnvelopeSimple,
  Shield: ShieldCheck,
  Package,
  Warehouse,
  LayoutDashboard: SquaresFour,
  GitBranch,
  Users: UsersThree,
  UsersRound: UsersThree,
  Database,
  Calendar: CalendarBlank,
  FileStack: Files,
  FolderLock: Folder,
  Landmark: Bank,
  Plane: Airplane,
  Plug,
  Store: Storefront,
  Wallet,
};

/** Komponent Phosphor dla nazwy ikony (lucide); brak → `Cube`. Renderuj z `weight="duotone"`. */
export function phosphorIconFor(name: string | null | undefined): PhosphorIcon {
  return (name && PHOSPHOR_BY_LUCIDE_NAME[name]) || Cube;
}
